<template>
   <v-layout row wrap>
    <v-flex sm12 md12 class="px-5 tabulardata">
      <v-text-field
        class="search-input"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-flex> 

    <v-flex sm12 md12>
      <div class="text-center mb-4">
        <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
      </div>
      <v-data-table
      :headers="headers"
      :items="locationList"
      :search="search"
      class="px-5 pb-4 tabulardata"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.name">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">
              <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="addUsers(item)"
                      fab 
                      dark 
                      small 
                      color="primary"
                      v-on="on"
                      :class="'mr-2'"
                      depressed
                    >
                      <v-icon dark>person_add</v-icon>
                    </v-btn>
                  </template>
                  <span>Manage Location Users</span>
                </v-tooltip>
              </td>
            </tr>
            <tr v-if="locationList.length < 1">
               <p class="text-xs-center mt-2 mb-0">You have not yet created any locations. you can create your first location by clicking the + button</p>
            <tr/>
          </tbody>
        </template>

      </v-data-table>
    </v-flex>

   </v-layout>
</template>

<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Name', value: 'name', sortable: true, class: 'font-weight-bold' },
        { text: 'Action', value: 'name', sortable: false, class: 'font-weight-bold' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      locationList: 'location/list',
    }),
  },
  created() {
    this.fetchLocations();
  },
  methods: {
    /**
    * Get all locations
    */
    fetchLocations() {
      const url = `${Env.url}/api/v1/locations/${ this.$store.getters.getLoggedInUserSelectedBusinessId }`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setList(res.data.payload);
      })
      .catch((err) => {
        this.snackbar({
          text: err.response.data.msg,
          timeout: 3000,
          open: true,
        });
        console.log('Unable to fetch locations.')
      });
    },

    /**
     * Add users
     */
    addUsers(obj) {
      this.setEditUser(true);
      this.setEditUserObj(obj);
    },
   
    ...mapActions({
      setEditUser: 'location/setEditUser',
      setEditUserObj: 'location/setEditUserObj',
      setList: 'location/setList',
      snackbar: 'snackbar/snackbar',
    }),
    
  },
};
</script>
